import React, { useEffect, useState } from 'react';
import ReactExport from 'react-data-export';
import { Button, Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileDownload } from '@fortawesome/free-solid-svg-icons';
import _ from 'lodash';
import FiterAPI from '../fiterAPI';

const { ExcelFile } = ReactExport;
const { ExcelSheet } = ReactExport.ExcelFile;

function numberToState(value) {
  return (
    (value < 10 && {
      value: 'PD',
      style: { font: { color: { rgb: 'dc3545' } } }
    }) ||
    (value <= 15 && {
      value: 'Neutro',
      style: { font: { color: { rgb: 'dcc335' } } }
    }) || { value: 'Força', style: { font: { color: { rgb: '2dba2d' } } } }
  );
}

function ExportAbstentions(props) {
  const { monthFilter, areasFilter = [], unitFilter = [] } = props;
  const [dataList, setDataList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [fileName, setFileName] = useState('export');

  async function getPulsesData() {
    setIsLoading(true);
    const { data } = await FiterAPI.getAbstentions({
      limit: 30000,
      monthFilter,
      areasFilter,
      unitFilter
    });
    const date = new Date();
    setFileName(
      !monthFilter?.filterKey
        ? `abstenções-${date.getUTCDate()}-${date.getUTCMonth() +
            1}-${date.getUTCFullYear()}`
        : `abstenções-${monthFilter?.filterKey}`
    );

    const dataAnswer = [];
    _.map(data, (user, index) => {
      dataAnswer[index] = [
        { value: user.name },
        { value: user.cpf },
        { value: user.areaLabel },
        { value: user.courseLabel },
        { value: user.unitLabel }
      ];
    });

    const dataSet = [
      {
        columns: [
          { title: 'Nome', width: { wpx: 80 } },
          { title: 'CPF', width: { wpx: 80 } },
          { title: 'Área', width: { wpx: 80 } },
          { title: 'Cargo', width: { wpx: 80 } },
          { title: 'Unidade', width: { wpx: 80 } }
        ],
        data: dataAnswer
      }
    ];
    setDataList(dataSet);
    setIsLoading(false);
  }

  async function showModal() {
    setShow(true);

    await getPulsesData();
  }
  return (
    <>
      <Button variant="secondary" onClick={() => showModal(true)}>
        <FontAwesomeIcon icon={faFileDownload} />
        <span>Exportar abstenções do mês.</span>
      </Button>
      <Modal show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton />
        <Modal.Body>
          {isLoading ? (
            <>
              <h4>Gerando download...</h4>
              <div className="spinner-border" />
            </>
          ) : (
            <ExcelFile filename={fileName}>
              <ExcelSheet
                dataSet={dataList}
                element={<FontAwesomeIcon icon={faFileDownload} />}
                name="Organization"
              />
            </ExcelFile>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
}
export default ExportAbstentions;
